import api from '../../../api/tarifications/_tarifications'

const state = () => ({
    tarif_consultations_generalistes: [],
    tarif_consltations_specialistes: [],
    prix_unitaire_cat_onmt: [],

    tarif_analyses: [],
    tarif_chirurgies: [],
    tarif_examen_para: [],
    tarif_medicaments: [],
    tarif_consommables: [],
    tarif_bilan_sante: [],
    tarification_actes: [],
    tarif_chambres: [],
    tarif_observations: [],
    tarif_admissions: [],

    tarif_hospitalisations: [],
    tarif_autre_admissions: [],

    tarif_actes: [],
    tarif_autre_actes: [],
    tarif_soin_actes: [],

    types_facturation_prestation: [],
})

// getters
const getters = {
    tarif_consultations_generalistes: (state) => {
        return state.tarif_consultations_generalistes
    },

    tarif_consltations_specialistes: (state) => {
        return state.tarif_consltations_specialistes
    },

    prix_unitaire_cat_onmt: (state) => {
        return state.prix_unitaire_cat_onmt
    },

    tarif_analyses: (state) => {
        return state.tarif_analyses
    },

    tarif_chirurgies: (state) => {
        return state.tarif_chirurgies
    },

    tarif_examen_para: (state) => {
        return state.tarif_examen_para
    },

    tarif_medicaments: (state) => {
        return state.tarif_medicaments
    },

    tarif_consommables: (state) => {
        return state.tarif_consommables
    },

    tarif_hospitalisations: (state) => {
        return state.tarif_hospitalisations
    },

    tarif_autre_admissions: (state) => {
        return state.tarif_autre_admissions
    },

    tarif_actes: (state) => {
        return state.tarif_actes
    },

    tarif_autre_actes: (state) => {
        return state.tarif_autre_actes
    },

    tarif_soin_actes: (state) => {
        return state.tarif_soin_actes
    },

    tarif_bilan_sante: (state) => {
        return state.tarif_bilan_sante
    },

    tarification_actes: (state) => {
        return state.tarification_actes
    },

    tarif_chambres: (state) => {
        return state.tarif_chambres
    },

    tarif_observations: (state) => {
        return state.tarif_observations
    },

    tarif_admissions: (state) => {
        return state.tarif_admissions
    },

    types_facturation_prestation: (state) => {
        return state.types_facturation_prestation
    },
}

// mutations
const mutations = {
    SET_TARIF_CONSULTATIONS_GENERALISTES(state, tarif) {
        state.tarif_consultations_generalistes = tarif
    },

    SET_TARIF_CONSULTATIONS_SPECIALISTES(state, tarif) {
        state.tarif_consltations_specialistes = tarif
    },

    SET_PRIX_UNITAIRE_CAT_ONMT(state, pu) {
        state.prix_unitaire_cat_onmt = pu
    },

    SET_TARIF_ANALYSES(state, tarif) {
        state.tarif_analyses = tarif
    },

    SET_TARIF_CHIRURGIES(state, tarif) {
        state.tarif_chirurgies = tarif
    },

    SET_TARIF_EXAMENS_PARA(state, tarif) {
        state.tarif_examen_para = tarif
    },

    SET_TARIF_MEDICAMENTS(state, tarif) {
        state.tarif_medicaments = tarif
    },

    SET_TARIF_CONSOMMABLES(state, tarif) {
        state.tarif_consommables = tarif
    },

    SET_TARIF_HOSPITALISATIONS(state, tarif) {
        state.tarif_hospitalisations = tarif
    },

    SET_TARIF_AUTRE_ADMISSIONS(state, tarif) {
        state.tarif_autre_admissions = tarif
    },

    SET_TARIF_ACTES(state, tarif) {
        state.tarif_actes = tarif
    },

    SET_TARIF_AUTRE_ACTES(state, tarif) {
        state.tarif_autre_actes = tarif
    },

    SET_TARIF_SOIN_ACTES(state, tarif) {
        state.tarif_soin_actes = tarif
    },

    SET_TARIF_BILAN_SANTE(state, tarif) {
        state.tarif_bilan_sante = tarif
    },

    SET_TARIFICATION_ACTES(state, tarif) {
        state.tarification_actes = tarif
    },

    SET_TARIF_CHAMBRES(state, tarif) {
        state.tarif_chambres = tarif
    },

    SET_TARIF_OBSERVATIONS(state, tarif) {
        state.tarif_observations = tarif
    },

    SET_TARIF_ADMISSIONS(state, tarif) {
        state.tarif_admissions = tarif
    },

    SET_TYPES_FACTURATION_PRESTATION(state, types) {
        state.types_facturation_prestation = types
    },
}

// actions
const actions = {
    getTarifConsultationsByCategorie({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getTarifConsultationsGeneralistes(data).then(
                response => {
                    if (data.categorie_id == 1) {
                        commit('SET_TARIF_CONSULTATIONS_GENERALISTES', response)
                        resolve(response)
                    } else if (data.categorie_id == 2) {
                        commit('SET_TARIF_CONSULTATIONS_SPECIALISTES', response)
                        resolve(response)
                    }
                }, error => {
                    reject(error)
                }
            )
        })
    },

    addConsultationPrestation({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.addConsultationPrestation(data).then(
                response => {
                    dispatch
                    // dispatch('getTarifConsultationsByCategorie', { categorie_id: 1 })
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    deleteTarifConsultation({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.deleteTarifConsultation(data).then(
                response => {
                    dispatch
                    // dispatch('getTarifConsultationsByCategorie', { categorie_id: 1 })
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getPrixUnitaireCatOnmt({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getPrixUnitaireCatOnmt(data).then(
                response => {
                    commit('SET_PRIX_UNITAIRE_CAT_ONMT', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    /**
     * Mettre à jour les prix unitaires CAT / ONMT
     * @param {*} param0 
     * @param {*} data 
     * @returns 
     */
    updatePrixCatOnmt({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.updatePrixCatOnmt(data).then(
                response => {
                    dispatch('getTarifConsultationsByCategorie', 'consultation_generaliste')
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getTarifAnalyse({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getTarifAnalyse(data).then(
                response => {
                    commit('SET_TARIF_ANALYSES', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    // --------->>>> TYPE PRESTATION - ANALYSE
    addAnalysePrestation({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.addAnalysePrestation(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    // >>>>>>>>>>  CHIRURGIES
    getTarifChirurgie({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getTarifChirurgie(data).then(
                response => {
                    commit('SET_TARIF_CHIRURGIES', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    addChirurgiePrestation({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.addChirurgiePrestation(data).then(
                response => {
                    dispatch('getTarifChirurgie')
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    // >>>>>>>>>        Examens para
    getTarifExamenPara({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getTarifExamenPara(data).then(
                response => {
                    commit('SET_TARIF_EXAMENS_PARA', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveExamenPara({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.saveExamenPara(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    // >>>>>>  TARIF MEDICAMENTS
    getTarifMedicament({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getTarifMedicament(data).then(
                response => {
                    commit('SET_TARIF_MEDICAMENTS', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getTarifConsommable({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getTarifConsommable(data).then(
                response => {
                    commit('SET_TARIF_CONSOMMABLES', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveMedicament({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.saveMedicament(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getTarifTypeAdmission({ commit }, type_admission) {
        return new Promise((resolve, reject) => {
            api.getTarifTypeAdmission(type_admission).then(
                response => {
                    if (type_admission == 'chambre') {
                        commit('SET_TARIF_HOSPITALISATIONS', response)
                        resolve(response)
                    } else if (type_admission == 'autre_admission') {
                        commit('SET_TARIF_AUTRE_ADMISSIONS', response)
                        resolve(response)
                    }
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveTypeAdmission({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.saveTypeAdmission(data).then(
                response => {
                    dispatch('getTarifTypeAdmission', data.type)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    deleteTypeAdmission({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.deleteTypeAdmission(data).then(
                response => {
                    dispatch('getTarifTypeAdmission', data.type)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getTarifActes({ commit }, type_acte) {
        return new Promise((resolve, reject) => {
            api.getTarifActes(type_acte).then(
                response => {
                    if (type_acte == 'acte') {
                        commit('SET_TARIF_ACTES', response)
                        resolve(response)
                    } else if (type_acte == 'autre_acte') {
                        commit('SET_TARIF_AUTRE_ACTES', response)
                        resolve(response)
                    }
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveActe({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.saveActe(data).then(
                response => {
                    dispatch('getTarifActes', data.type)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    deleteActe({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.deleteActe(data).then(
                response => {
                    dispatch('getTarifActes', data.type)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getTarifSoins({ commit } ) {
        return new Promise((resolve, reject) => {
            api.getTarifSoins().then(
                response => {
                    commit('SET_TARIF_SOIN_ACTES', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveSoin({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.saveSoin(data).then(
                response => {
                    dispatch('getTarifSoins')
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    deleteSoin({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.deleteSoin(data).then(
                response => {
                    dispatch('getTarifActes')
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    // +++++++  BILAN DE SANTE  +++++++
    getTarifBilanSante({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getTarifBilanSante(data).then(
                response => {
                    commit('SET_TARIF_BILAN_SANTE', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveTarifBilanSante({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.saveTarifBilanSante(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getTarificationActe({commit}, data) {
        return new Promise((resolve, reject) => {
            api.getTarificationActe(data).then(
                response => {
                    commit('SET_TARIFICATION_ACTES', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveTarifActe({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.saveTarifActe(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getTarificationTypeAdmission({commit}, data) {
        return new Promise((resolve, reject) => {
            api.getTarificationTypeAdmission(data).then(
                response => {
                    if (data.data_type == 'chambre') {
                        commit('SET_TARIF_CHAMBRES', response)
                    } else if (data.data_type == 'observation') {
                        commit('SET_TARIF_OBSERVATIONS', response)
                    } else if (data.data_type == 'admission') {
                        commit('SET_TARIF_ADMISSIONS', response)
                    }
                    
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveTarifTypeAdmission({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.saveTarifTypeAdmission(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveTarifArticle({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.saveTarifArticle(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    /**
     * Types de facturation des prestations (normal / urgence)
     * Repli sur normal / urgence si la liste est vide ou si l'appel échoue
     */
    getTypesFacturationPrestation({commit}) {
        const types_par_defaut = [{ value: 'normal' }, { value: 'urgence' }]

        return new Promise((resolve) => {
            api.getTypesFacturationPrestation().then(
                response => {
                    const types = (Array.isArray(response) && response.length > 0) ? response : types_par_defaut
                    commit('SET_TYPES_FACTURATION_PRESTATION', types)
                    resolve(types)
                }, () => {
                    commit('SET_TYPES_FACTURATION_PRESTATION', types_par_defaut)
                    resolve(types_par_defaut)
                }
            )
        })
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}